import { render, staticRenderFns } from "./IconSvgFacebook.vue?vue&type=template&id=1b234d84&scoped=true&"
import script from "./IconSvgFacebook.vue?vue&type=script&lang=js&"
export * from "./IconSvgFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b234d84",
  null
  
)

export default component.exports